import React, { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import IVRHERO from "../../assets/product/IVR-Hero.png";
import OurClients from "../OurClients/OurClients";
import "animate.css";
import Aos from "aos";
import "aos/dist/aos.css";
import AOS from "aos";
import BgImg from "../../assets/portfolio/bg2.png";
import Intrecative from "../../assets/product/Interactive-Voice-Response.jpeg";
import {
  faPhoneVolume,
  faUserGear,
  faMicrophone,
  faPlayCircle,
  faListUl,
  faCloudArrowDown,
} from "@fortawesome/free-solid-svg-icons";

import {
  faDollarSign,
  faSmile,
  faChartLine,
  faDatabase,
  faGlobe,
  faIndustry,
} from "@fortawesome/free-solid-svg-icons";

import IvrWorking from "../Website/IvrWorking";
import IvrWorks from "./WebProduct/IvrWork";
import { Helmet } from "react-helmet-async";
const InteractiveVoiceResponse = () => {
  useEffect(() => {
    Aos.init({
      duration: 1000,
      once: true,
    });
  }, []);
  // benifits data
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);
  const benifits = [
    {
      icon: faDollarSign,
      title: "Cost Efficiency",
      description:
        "IVR Solution can significantly reduce the need for live agents by automating simple tasks and interactions.",
      animation: "fade-up",
    },
    {
      icon: faSmile,
      title: "Improved Customer Experience",
      description:
        "By offering self-service options and ensuring efficient call routing, IVR reduces wait times and improves the customer experience. It is also available 24/7.",
      animation: "fade-up",
    },
    {
      icon: faChartLine,
      title: "Scalability",
      description:
        "Our IVR Solution can easily scale to handle increased call volumes as businesses grow, with minimal additional investment.",
      animation: "fade-up",
    },
    {
      icon: faDatabase,
      title: "Data Collection",
      description:
        "IVR Solutions collect valuable customer data to uncover insights into behavior, preferences, and pain points—helping improve services.",
      animation: "fade-up",
    },
    {
      icon: faGlobe,
      title: "Multilingual Support",
      description:
        "IVR Solutions support multiple languages, making them ideal for companies with a diverse or global customer base.",
      animation: "fade-up",
    },
    {
      icon: faIndustry,
      title: "Suitable for Every Industry",
      description:
        "Custom IVR Solutions tailored for Banking, Healthcare, Telecom, Customer Support, and more.",
      animation: "fade-up",
    },
  ];
  // ivr key features of ivr solution
  const features = [
    {
      id: 1,
      icon: faPhoneVolume,
      title: "Call Routing",
      description: `
      Routing calls to the appropriate department or individual based on the caller's selection. A customer calls a company and an IVR system greets them. The system might say, "Press 1 for sales, 2 for support, 3 for billing." Based on the caller's selection (press 2), the call is routed to the support department.`,
    },
    {
      id: 2,
      icon: faUserGear,
      title: "Self-Service Options",
      description: `Our IVR solution allows you to access self-services such as checking account balances, paying bills, or updating personal information without the need for speaking with a live representative`,
    },
    {
      id: 3,
      icon: faMicrophone,
      title: "Speech Recognition",
      description: `With speech recognition technology, our IVR solution enabling callers to speak their responses instead of using a keypad. This creates a more seamless and natural interaction, reducing frustration and improving overall experience. `,
    },
    {
      id: 4,
      icon: faPlayCircle,
      title: "Pre-recorded Messages and Prompts",
      description: `Pre-recorded voice messages guide the caller through the available options. These can be customized to suit the specific needs of a business and can include multi-lingual prompts for diverse customer bases. `,
    },
    {
      id: 5,
      icon: faListUl,
      title: "Multi-level Menus",
      description: `Our IVR solution provides you multi-level menus where users can drill down through several options to access more specific services.  
For instance, after selecting “customer service” in the first menu, callers may be asked to select a specific issue (e.g., billing, technical support, or account updates).`,
    },
    {
      id: 6,
      icon: faCloudArrowDown,
      title: "Real-Time Data Integration",
      description: `Our IVR solution can integrate with backend databases or CRM (Customer Relationship Management) systems to provide real-time information.  
For example, an IVR in a bank can access a customer’s account details in real-time to provide balance information or recent transactions`,
    },
  ];

  // working data

  return (
    <>
      <Helmet>
        <title>Interactive Voice Response (IVR) Solutions – Deetyasoft</title>
        <meta
          name="description"
          content="Deetya Soft’s IVR Guru offers advanced Interactive Voice Response services—automate calls, route queries, record interactions & enhance customer service"
        />
        <meta
          name="keywords"
          content="Interactive Voice Response, IVR, IVR Guru, automated telephony, call routing, cloud IVR, Deetya Soft, virtual number, call recording "
        />
        <link
          rel="canonical"
          href="https://deetyasoft.com/interactive-voice-response"
        />

        {/* <!-- Facebook Meta Tags --> */}
        <meta property="og:locale" content="en_IN" />
        <meta property="og:type" content="article" />
        <meta
          property="og:url"
          content="https://deetyasoft.com/interactive-voice-response"
        />
        <meta
          property="og:title"
          content="Interactive Voice Response (IVR) Solutions – Deetyasoft"
        />
        <meta
          property="og:description"
          content="Deetya Soft’s IVR Guru offers advanced Interactive Voice Response services—automate calls, route queries, record interactions & enhance customer service"
        />
        <meta
          property="og:image"
          content="https://deetyasoft.com/static/media/Interactive-Voice-Response.f5ab8683b3c35541ad40.jpeg"
        />
        <meta property="og:site_name" content="deetyasoft.com" />
        <meta
          property="article:publisher"
          content="https://www.facebook.com/deetyasoftprivatelimited"
        />

        {/* <!-- Twitter Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:url"
          content="https://deetyasoft.com/interactive-voice-response"
        />
        <meta
          name="twitter:title"
          content="Interactive Voice Response (IVR) Solutions – Deetyasoft"
        />
        <meta
          name="twitter:description"
          content="Deetya Soft’s IVR Guru offers advanced Interactive Voice Response services—automate calls, route queries, record interactions & enhance customer service"
        />
        <meta
          name="twitter:image"
          content="https://deetyasoft.com/static/media/Interactive-Voice-Response.f5ab8683b3c35541ad40.jpeg"
        />
        <meta name="twitter:site" content="@DeetyaSoft" />
        <meta name="twitter:creator" content="@DeetyaSoft" />

        <meta name="yandex-verification" content="31c730ea93a5a9cd" />
        <meta name="copyright" content="Deetyasoft" />
        <meta name="author" content="Deetyasoft" />
        <meta name="email" content="info@deetyasoft.com" />
        <meta name="Distribution" content="Global" />
        <meta name="rating" content="general" />
        <meta name="robots" content="index, follow" />
        <meta name="googlebot" content="index, follow" />
        <meta property="bingbot" content="index, follow " />
        <meta name="Yahoobot" content="index, follow" />
        <meta name="MSNbot" content="index, follow" />
        <meta name="googlebot-news" content="index, follow" />
        <meta name="audience" content="all" />
        <meta name="geo.placename" content="Noida, Uttar Pradesh, India" />
        <meta name="geo.region" content="IN-UP" />
        <meta name="geo.position" content="28.644800;77.373300" />
        <meta name="ICBM" content="28.644800, 77.373300" />
        <link rel="alternate" href="https://deetyasoft.com" hreflang="en-us" />
        <meta http-equiv="content-language" content="en-us" />
        <meta name="msvalidate.01" content="305155CCD42FD63B0A29555BBEE7CA03" />

        {/* <!-- Id+json scripts --> */}

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "http://schema.org",
            "@type": "Organization",
            name: "Deetya Soft Pvt Ltd",
            description:
              "Deetya Soft’s IVR Guru offers advanced Interactive Voice Response services—automate calls, route queries, record interactions & enhance customer service",
            image:
              "https://deetyasoft.com/static/media/Interactive-Voice-Response.f5ab8683b3c35541ad40.jpeg",
            logo: "https://www.deetyasoft.com/images/logo.png",
            url: "https://www.deetyasoft.com",
            telephone: ["+91-9015350505", "+91-9717055088"],
            email: "info@deetyasoft.com",
            sameAs: [
              "https://www.linkedin.com/company/deetya-soft-private-limited",
              "https://www.facebook.com/deetyasoftprivatelimited",
              "https://www.instagram.com/deetyasoft",
              "https://www.youtube.com/@deetyasoft",
              "https://www.crunchbase.com/organization/deetyasoft",
            ],
            address: {
              "@type": "PostalAddress",
              streetAddress:
                "FF‑06, First Floor, Mahaluxmi Square, Plot No. C‑1, Abhay Khand II, Indirapuram",
              addressLocality: "Ghaziabad",
              addressRegion: "Uttar Pradesh",
              postalCode: "201014",
              addressCountry: "IN",
            },
          })}
        </script>

        {/* Contact Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "http://schema.org",
            "@type": "Organization",
            url: "https://www.deetyasoft.com",
            contactPoint: [
              {
                "@type": "ContactPoint",
                telephone: "+91-981-862-7588",
                contactType: "technical support",
                areaServed: "IN",
              },
              {
                "@type": "ContactPoint",
                telephone: "+91-901-535-0505",
                contactType: "sales",
                areaServed: "IN",
              },
            ],
          })}
        </script>

        {/* Review Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "http://schema.org",
            "@type": "Review",
            author: {
              "@type": "Person",
              name: "Parshan",
            },
            reviewBody:
              "Deetya Soft helps companies to enable effective business operations through custom web solutions, IVR, and cloud telephony services.",
            url: "https://www.deetyasoft.com/",
            description:
              "Deetya Soft Pvt Ltd offers services such as IVR systems, virtual phone numbers, toll-free numbers, call tracking, enquiry management, LMS, web solutions, VOIP, and cloud-based communication solutions.",
            datePublished: "2025-06-17",
            name: "Deetya Soft Pvt Ltd",
            reviewRating: {
              "@type": "Rating",
              worstRating: "1",
              ratingValue: "5",
              bestRating: "5",
            },
            itemReviewed: {
              "@type": "Organization",
              name: "Deetya Soft Pvt Ltd",
            },
          })}
        </script>
      </Helmet>
      <div>
        {/* done */}
        <div className="relative bg-gradient-to-r from-[#0B0F2F] to-[#12164E] text-white py-10 px-4 md:px-8 lg:px-8 overflow-hidden">
          {/* Decorative Background Circles */}
          <div className="absolute top-[-100px] left-[-100px] w-[300px] h-[300px] bg-blue-500 opacity-30 rounded-full blur-3xl z-0" />
          <div className="absolute bottom-[-150px] right-[-100px] w-[400px] h-[400px] bg-blue-600 opacity-20 rounded-full blur-3xl z-0" />

          <div className="relative z-10 max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left Text Content */}
            <div>
              <h1 className="text-2xl md:text-4xl lg:text-4xl font-bold leading-tight text-[#8cd3fe]">
                Interactive Voice Response
              </h1>
              <p className="md:mt-6  mt-4 text-gray-300 text-[15px] md:text-lg">
                We at Deetyasoft provides you fully automated Interactive Voice
                Response (IVR) solution that interacts with your callers,
                gathers information through keypress or speech recognition, and
                routes calls to your appropriate recipient or to the concerned
                department. Our IVR solution are widely used in businesses of
                every industry in PAN India.
              </p>
              <button className="hidden md:block mt-8 px-6 py-3 rounded-full bg-main1 hover:bg-[#1c7ed6] text-white font-medium transition">
                Know More
              </button>
            </div>

            {/* Right Image/Graphic Content */}
            <div className="flex justify-center items-center">
              <img
                src={IVRHERO}
                alt="ivr-hero"
                className="w-full max-w-md md:max-w-md lg:max-w-md"
              />
            </div>
          </div>
        </div>
        {/* main here */}
        <div className="bg-blue-50 py-16 px-4 sm:px-6 lg:px-8">
          <div className="container mx-auto text-center">
            <h3 className="text-2xl md:text-4xl mb-3 font-semibold">
              Interactive Voice Response (IVR)
            </h3>
            <div className="w-28 sm:w-32 md:w-40 h-1 bg-main1 mx-auto mb-5 rounded-full" />
          </div>

          {/* Section 1: Image on left, text on right */}
          <div className="max-w-screen-xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div className="w-full px-2 md:order-1 order-2">
              <img
                src={Intrecative} // Your image import or path
                alt="Intrecative"
                className="w-full h-auto object-cover rounded-lg"
              />
            </div>

            <div className="px-4 lg:px-8 order-2 md:order-1">
              <p className="text-gray-700 md:text-base text-sm text-justify leading-relaxed">
                We at Deetyasoft provides you fully automated Interactive Voice
                Response (IVR) solution that interacts with your callers,
                gathers information through keypress or speech recognition, and
                routes calls to your appropriate recipient or to the concerned
                department. Our IVR solution are widely used in businesses of
                every industry in PAN India.
                <br />
                Our IVR solution are used in a variety of sectors including
                telecommunications, banking, educational, healthcare, retail,
                and government. The goal of an IVR system is to provide callers
                with quick and efficient service by automating repetitive tasks
                that would otherwise require a live agent.
              </p>
            </div>
          </div>
        </div>
        {/* key features of ivr solution */}
        <div className=" bg-primaryPri">
          <div className="max-w-7xl mx-auto py-12  px-4 sm:px- lg:px-10">
            <h2 className="text-3xl font-bold text-center mb-5">
              Key Features of Our IVR Solution
            </h2>
            <div className="md:w-40 w-20  h-1 bg-main mx-auto mb-10 rounded"></div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {features?.map((type) => (
                <div
                  key={type.id}
                  className="flex items-start bg-white shadow-xl p-6 rounded-lg border-l-2 border-main transition-transform duration-300 hover:-translate-y-1 hover:shadow-lg"
                >
                  <FontAwesomeIcon
                    icon={type.icon}
                    size="2x"
                    className="text-main mr-4 mt-1"
                  />
                  <div>
                    <h4 className="text-xl font-semibold mb-2">{type.title}</h4>
                    <p className="text-gray-600">{type.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        {/* working of the ivr sectuon */}

        <IvrWorks />
        {/* benifits  section  */}
        <div
          className="py-5 md:px-20 px-3 relative"
          data-aos="fade-up"
          style={{
            backgroundImage: `url(${BgImg})`,
            backgroundRepeat: "repeat",
            backgroundSize: "auto",
            backgroundPosition: "center",
            backgroundAttachment: "fixed",
            minHeight: "60vh",
          }}
        >
          <div className="text-center py-10 px-4">
            {/* Main Heading */}
            <h2 className="text-2xl md:text-4xl font-semibold">
              <span className="text-black">Benefits Of Interactive </span>
              <span className="text-sky-500"> Voice Response</span>
            </h2>

            {/* Decorative Underline */}
            <div className="relative w-fit mx-auto mt-2">
              <div className="h-[1px] bg-gray-300 md:w-[300px] w-[150px] mx-auto"></div>
              <div className="absolute left-1/2 -translate-x-1/2 -top-[1px] flex gap-2">
                <div className="w-8 h-[2px] bg-sky-500"></div>
                <div className="w-8 h-[2px] bg-sky-500"></div>
                <div className="w-8 h-[2px] bg-sky-500"></div>
              </div>
            </div>
          </div>

          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {benifits.map((card, index) => (
                <div
                  key={index}
                  className="bg-gray-50 rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300"
                  data-aos={card.animation}
                  data-aos-delay={(index + 1) * 100}
                >
                  <div className="p-8 text-center">
                    <div className="flex justify-center mb-6">
                      <FontAwesomeIcon
                        icon={card.icon}
                        size="2x"
                        className="text-main"
                      />
                    </div>
                    <h5 className="md:text-lg text-base  font-semibold text-gray-800 mb-3">
                      {card.title}
                    </h5>
                    <p className="text-sm text-gray-600">{card.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        {/* ivr working section is here */}
        <div>
          <IvrWorking />
        </div>
        {/* client */}
        <div>
          <OurClients />
        </div>
      </div>
    </>
  );
};

export default InteractiveVoiceResponse;
